import {obtenerReservasEntreFechas} from "./obtenerReservasEntreFechas";
import {filtrarReservas} from "../Funciones/filtrarReservas";
import {ESTADOSRESERVAS} from "../Constantes";

export const obtenerHabitacionesOcupadasEntreFechas = async ({fechaCheckIn, fechaCheckOut}) => {

    let arrReservas = await obtenerReservasEntreFechas({fechaCheckIn: fechaCheckIn, fechaCheckOut: fechaCheckOut})

    let arrReservasDeOcupacion = filtrarReservas({
        reservas: arrReservas,
        estados: [ESTADOSRESERVAS[3], ESTADOSRESERVAS[4], ESTADOSRESERVAS[5]],
    })


    let arrNumeroHabitacionReservada = arrReservasDeOcupacion.map((it) => it.numero)

    let set = new Set(arrNumeroHabitacionReservada)

    return [...set]

}